module.exports = __webpack_public_path__ + "static/img/integralruletegs.f53e8fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integralruletegs.png
// module id = z+NF
// module chunks = 1